
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import { InventoryItemListItem } from "@/models/api/barcodeSystem/inventory/inventoryItems";

const inventoryModuleState = getModule(InventoryModule);

import draggable from "vuedraggable";

import RightClickMenu from "@/components/widgets/RightClickMenu.vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { LinkInventoryRequest, UnspecifiedItem } from "@/models/api/barcodeSystem/barcodeOrders/linkInventory";
import { AvailableQuantityRequest } from "@/models/api/barcodeSystem/inventory/getAvailableQuantity";
import notifications from "@/lib/notifications";

@Component({
  components: {
    RightClickMenu,
    draggable
  }
})
export default class LinkInventoryItemTable extends Vue {
  @Prop({ default: "table" })
  public id: string;

  @Prop({ default: "" })
  public containerClass: string;

  @Prop({ default: null })
  public tableField: Array<any>;

  @Prop({ default: null })
  public tableMenuItem: Array<any>;

  @Prop({ default: null })
  public linkInventoryRequest: LinkInventoryRequest;

  public rightClickLocation: any = null;
  public showHelp: boolean = false;
  public draggingData: boolean = false;
  public availableQuantity: number = 0;
  public quantity: number = 0;
  public showQuantityPrompt: boolean = false;
  public loadingAvailableQuantity: boolean = false;

  get filterFields() {
    let filterFields = this.tableField.filter(
      field => field.hidden === false && field.key !== "selected"
    );
    return filterFields;
  }

  set filterFields(newValue) {
    this.$emit("updateFields", newValue);
  }

  get linkInventoryItems(): Array<InventoryItemListItem> {
    return inventoryModuleState.linkItemData.filter(x => !this.linkInventoryRequest.specifiedItems.some(y => y.id == x.id));
  }

  get loading(): boolean {
    return inventoryModuleState.loading;
  }

  get selectedItemCount(): number {
    return inventoryModuleState.getSelectedLinkItemCount;
  }

  get selectedItems(): Array<any> {
    return inventoryModuleState.getSelectedLinkItems;
  }

  
  get totalItems() {
    if (inventoryModuleState.linkItemPageData) {
      const items = inventoryModuleState.linkItemPageData.totalItems;
      return items ? items : 0;
    } else {
      return 0;
    }
  }

  
  get currentSortAscending() {
    return inventoryModuleState.linkItemDataSortAscending;
  }
  get currentSort() {
    return inventoryModuleState.linkItemDataSortKey;
  }

  unselectAll() {
    let summaryItems = this.selectedItems;

    summaryItems.forEach(summary => {
      inventoryModuleState.switchLinkItemSelectionStatus(summary.id);
    });
  }

  getComponentData(rowData) {
    return {
      on: {
        click: () => this.onRowClick(rowData),
        contextmenu: $event => this.onRightClicked(rowData, $event),
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }
  canMove() {
    return false;
  }
  putFeature() {
    return false;
  }
  sort(s) {
    this.$emit("sort", s);
  }

  onRightClicked(rowData, event) {
    event.preventDefault();
    if (!rowData.selected) inventoryModuleState.switchLinkItemSelectionStatus(rowData.id);

    this.rightClickLocation = { x: event.x, y: event.y };
  }
  onDoubleClicked(data) {
    this.addItems([data]);
  }
  onRowClick(rowData) {
    inventoryModuleState.switchLinkItemSelectionStatus(rowData.id);

    this.clearRightClick();
  }
  clearRightClick() {
    this.rightClickLocation = null;
    this.draggingData = false;
  }

  clickMenu(item) {
    if(item.type == "addModel")
    {
      if(this.selectedItems && this.selectedItems.length == 1)
        this.promptForQuantity()
    } else {
      this.addItems(this.selectedItems);
    }
    this.clearRightClick();
  }

  async promptForQuantity() {
    let item = this.selectedItems[0];
    this.quantity = 0;
    this.availableQuantity = 0;
    this.loadingAvailableQuantity = true;
    this.showQuantityPrompt = true;
    try {
      let request = {
        facilityCode: item.facilityCode,
        companyId: item.companyId,
        manufacturerCode: item.manufacturerCode,
        modelNumber: item.modelNumber,
        poNumber: item.poNumber
      } as AvailableQuantityRequest;
      this.availableQuantity = await inventoryModuleState.getAvailableQuantity(request);
    } catch (ex) {
      notifications.error("Failed to load available quantity", "Failed to load available quantity.", ex);
      this.closeModals();
    } finally {
      this.loadingAvailableQuantity = false;
    }
  }

  addModel() {
    if(this.quantity == 0) {
      notifications.error("Enter Quantity", "You must enter a quantity to add model to order.");
      return
    }

    if(this.quantity > this.availableQuantity) {
      notifications.error("Entered Quantity Exceeeds Available", "Quantity cannot exceed the available quantity.");
      return
    }

    if(this.quantity > 0) {
      let item = this.selectedItems[0];
      for(var i = 1;i<=this.quantity;i++)
      {
        this.linkInventoryRequest.unspecifiedItems.push({
          id: null,  
          facilityCode: item.facilityCode,
          companyId: item.companyId,
          companyName: item.company ? item.company.companyName : "",
          manufacturerCode: item.manufacturerCode,
          poNumber: item.poNumber,
          modelNumber: item.modelNumber,
        } as UnspecifiedItem);
      }
      notifications.success("Model Added", "Model added to order.");
      this.unselectAll();
      this.closeModals();
    }
  }

  addItems(items) {
    items.forEach(item => {
        if(!this.linkInventoryRequest.specifiedItems.some(x => x.id == item.id))
        {
          this.linkInventoryRequest.specifiedItems.push(item);
        }
      });
    if(items.length == 1)
      notifications.success("Item Added", "Item added to order.");
    else
      notifications.success("Items Added", "Items added to order.");
    this.unselectAll();
  }
  
  onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
    if (
      Math.ceil(scrollTop) + 1 + clientHeight >= scrollHeight &&
      !this.loading &&
      inventoryModuleState.linkItemPageData.totalItems > this.linkInventoryItems.length
    ) {
      this.$emit("loadMoreData");
    }
  }

  getFieldClass(field, itemData) {
    var fieldClass = null;
    if (field.textAlign) {
      switch (field.textAlign) {
        case "right":
          fieldClass = "text-right";
          break;
        case "left":
          fieldClass = "text-left";
          break;
        case "center":
          fieldClass = "text-center";
          break;
        default:
          break;
      }
    }

    if(field.noWrap)
    {
      fieldClass += " text-nowrap";
    }

    return fieldClass;
  }

  getValue(object, path) {
    if (!path) return;
    return path.split(".").reduce((r, k) => (r ? r[k] : ""), object);
  }

  closeModals() {
    this.showQuantityPrompt = false;
  }
}
